import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from '@mui/material';
const baseSx = {
    textAlign: 'center',
    border: '1px solid black',
    whiteSpace: 'nowrap',
    borderRadius: '3px',
    margin: '0 4px',
    padding: '0 6px 2px',
    fontSize: '17px',
    fontWeight: '400',
};
export function Kbd({ children }) {
    return (_jsx(Typography, { sx: baseSx, component: "span", children: children }));
}
